// Typelizer digest dfa13570758c693087bbfd6492c0f521
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /educators/teachers/:teacher_id/timetable_publications */
  create: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/timetable_publications', params, options),
    method: 'post',
  }),
}
